<script setup lang="ts">
import { type RouteLocationRaw } from 'vue-router'

export interface BreadcrumbItem {
  route?: RouteLocationRaw
  displayName: string
}

const props = defineProps<{ title?: string; items: BreadcrumbItem[] }>()
</script>

<template>
  <div class="layout">
    <header>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="i in props.items" :key="i.displayName" :to="i.route">{{
          i.displayName
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </header>
    <h2 v-if="props.title">{{ props.title }}</h2>
    <slot />
  </div>
</template>

<style scoped lang="scss">
.layout {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-spacing-lg);
  padding: var(--spacing-spacing-lg) var(--spacing-spacing-xl);
  min-width: 992px; /* temp until responsive update */

  &__back-button {
    display: inline-flex;
    align-items: center;
    gap: var(--spacing-spacing-md);
  }
}
</style>
